import { render, staticRenderFns } from "./ListarMigracaoGuias.vue?vue&type=template&id=36676828&"
import script from "./ListarMigracaoGuias.vue?vue&type=script&lang=js&"
export * from "./ListarMigracaoGuias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports